import styled from 'styled-components'
import { Typography } from './typography'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const StyledTypography = styled(Typography)`
  display: block;
  color: ${baseTheme.colors.dark};
  font-family: Inter, sans-serif;

  &.h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
  }
  &.h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 1.2;
  }

  &.h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
  }

  &.h4 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
  }

  &.h5 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }

  &.h6 {
    font-size: 10px;
    font-weight: 500;
    line-height: 1.6;
  }

  &.subtitle1 {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.75;
  }

  &.subtitle2 {
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
  }

  &.body1 {
    font-style: normal;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  &.body2 {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }

  &.caption {
    font-size: 10px;
    font-weight: 400;
    line-height: 1.66;
  }

  &.button1 {
    line-height: 120%;
    font-weight: 500;
    font-size: 12px;
  }

  &.button2 {
    line-height: 120%;
    font-weight: 500;
    font-size: 24px;
  }

  &.link {
    color: #743bbc;
    font-size: 14px;
    font-weight: 400;
    text-decoration-line: underline;
    cursor: pointer;
  }

  &.input-label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-wrap: nowrap;
  }

  &.input-helper-text {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
  }

  &.modal-title {
    font-style: normal;
    font-size: 18px;
    font-weight: 600;
    line-height: 140%;
  }

  &.bold {
    font-weight: 600;
  }

  &.white {
    color: ${baseTheme.colors.white};
  }

  &.grey {
    color: ${baseTheme.colors.greyTurquoise};
  }

  &.darkGrey {
    color: ${baseTheme.colors.darkGrey};
  }

  &.lightDark {
    color: ${baseTheme.colors.lightDark};
  }

  &.dark {
    color: #28252d;
  }

  &.violet {
    color: ${baseTheme.colors.violet};
  }

  &.darkRed {
    color: ${baseTheme.colors.darkRed};
  }

  &.purple {
    color: ${baseTheme.colors.purple};
  }
`
